import requestApi, { HTTP_METHOD } from '@/utils/axios.http';
import { TUserEntityRoleSchema } from '@/schemas/user-entity-role/user-entity-role.schema';
import { TOKEN_API_PUBLIC } from '@/utils/constant.utils';

const USER_ENTITY_ROLE_URI = '/userEntityRole';

export const createNewUserEntityRole = async (
  userEntityRole: TUserEntityRoleSchema
) => {
  return requestApi({
    url: USER_ENTITY_ROLE_URI,
    method: HTTP_METHOD.POST,
    body: userEntityRole,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getAllEntityRolesByUserId = async (userId: string) => {
  return requestApi({
    url: `${USER_ENTITY_ROLE_URI}/all/user/${userId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const getEntityRoleByUserId = async (userId: string) => {
  return requestApi({
    url: `${USER_ENTITY_ROLE_URI}/user/${userId}`,
    method: HTTP_METHOD.GET,
    headers: {
      'Content-Type': 'application/json',
      'x-api-token': TOKEN_API_PUBLIC,
    },
  });
};

export const deleteUserEntityRole = async (
  userEntityRole: TUserEntityRoleSchema
) => {
  return requestApi({
    url: `${USER_ENTITY_ROLE_URI}/delete`,
    method: HTTP_METHOD.DELETE,
    body: userEntityRole,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};

export const deleteManyUserEntityRoles = async (
  userEntityRoles: TUserEntityRoleSchema[]
) => {
  return requestApi({
    url: `${USER_ENTITY_ROLE_URI}/deleteMany`,
    method: HTTP_METHOD.DELETE,
    body: userEntityRoles,
    headers: {
      'Content-Type': 'application/json',
    },
  });
};
